import { Box, Container, Grid, Typography } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { BG_LIGHT, COLOR_PRIMARY, DARK_800 } from '../theme'
import { WaveDivider } from './WaveDivider'

export interface StatItem {
    value: string
    label: string
    href?: string
}

interface StatsSectionProps {
    stats: StatItem[]
    /** If provided, overrides the first stat's value (e.g. a live count from the API) */
    liveFirstStat?: number | null
}

export function StatsSection({ stats, liveFirstStat }: StatsSectionProps) {
    return (
        <>
            <WaveDivider top={BG_LIGHT} bottom={DARK_800} />
            <Box sx={{ backgroundColor: DARK_800, py: { xs: 8, md: 10 } }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4} sx={{ display: 'flex', justifyContent: 'space-around' }}>
                        {stats.map((stat, i) => {
                            const inner = (
                                <>
                                    <Typography sx={{ color: COLOR_PRIMARY, fontWeight: 800, fontSize: { xs: '36px', md: '44px' }, lineHeight: 1, mb: 1 }}>
                                        {i === 0 && liveFirstStat != null ? liveFirstStat.toLocaleString() : stat.value}
                                    </Typography>
                                    <Typography className="stat-label" sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '14px' }}>
                                        {stat.label}
                                        {stat.href && <OpenInNewIcon sx={{ fontSize: 13, verticalAlign: 'text-bottom', ml: 0.5 }} />}
                                    </Typography>
                                </>
                            )
                            return (
                                <Grid item xs={6} md={3} key={stat.label}>
                                    {stat.href ? (
                                        <Box
                                            component="a"
                                            href={stat.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                display: 'block', textAlign: 'center', textDecoration: 'none',
                                                borderRadius: 2, p: 1,
                                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' },
                                                '&:hover .stat-label': { textDecoration: 'underline' },
                                            }}
                                        >
                                            {inner}
                                        </Box>
                                    ) : (
                                        <Box sx={{ textAlign: 'center', p: 1 }}>{inner}</Box>
                                    )}
                                </Grid>
                            )
                        })}
                    </Grid>
                </Container>
            </Box>
            <WaveDivider top={DARK_800} bottom={BG_LIGHT} inverted />
        </>
    )
}
